import { render, staticRenderFns } from "./BatchModifySizeWeight.vue?vue&type=template&id=d7518f32&scoped=true"
import script from "./BatchModifySizeWeight.vue?vue&type=script&lang=js"
export * from "./BatchModifySizeWeight.vue?vue&type=script&lang=js"
import style0 from "./BatchModifyStock.vue?vue&type=style&index=0&id=d7518f32&prod&scoped=true&lang=css&external"
import style1 from "./BatchModifySizeWeight.vue?vue&type=style&index=1&id=d7518f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7518f32",
  null
  
)

export default component.exports